import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
import { GameState, GameStatus, GRID_SIZE } from '@utils/game/2048/constants.js';
import { aesEncrypt, getRandomElement, isOpenMobile } from '@utils/index.js';
import { gameAdv } from "@utils/gameAdv.js";
import vailcode from "@utils/errcode";
import { animate, spring } from "motion";
const walletVuex = createNamespacedHelpers("wallet");
export default {
  name: "2048Page",
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", 'setting']),
    nextBtnText() {}
  },
  data() {
    return {
      gameState: {
        ...GameState
      },
      revives: 10,
      maxRevives: 10,
      lastScore: 0,
      timeVal: null,
      stimeVal: null,
      leftTime: 0,
      prizePool: 0,
      timePeriod: "",
      userReward: null,
      popUserRewardShow: false,
      popGameRankShow: false,
      popStartShow: false,
      popLostShow: false,
      popOpenMobileShow: false,
      touchStart: null,
      nextId: 0
    };
  },
  watch: {
    gameState: {
      deep: true,
      handler(newVal, oldVal) {
        this.$nextTick(() => {
          this.runAppearAnimations();
          this.runMergeAnimations();
          this.runMoveAnimations();
        });
      }
    },
    "gameState.status": {
      handler(newVal, oldVal) {
        if (newVal === GameStatus.MENU) {
          this.popLostShow = false;
          this.popStartShow = true;
        }
        if (newVal === GameStatus.GAMEOVER) {
          this.popLostShow = true;
          this.popStartShow = false;
        }
        if (newVal === GameStatus.PLAYING) {
          this.popStartShow = false;
          this.popLostShow = false;
        }
      },
      deep: true,
      immediate: true
    },
    'gameState.score': {
      handler() {
        clearTimeout(this.timeVal);
        this.timeVal = setTimeout(() => {
          this.end();
        }, 500);
      },
      deep: true,
      immediate: true
    }
  },
  beforeRouteLeave(to, from, next) {
    try {
      window.removeEventListener('keydown', this.handleKeyDown);
      clearTimeout(this.stimeVal);
      clearTimeout(this.timeVal);
      this.end();
    } catch (error) {}
    this.$nextTick(() => {
      next();
    });
  },
  methods: {
    handleKeyDown(e) {
      switch (e.key) {
        case 'ArrowUp':
          this.handleMove('up');
          break;
        case 'ArrowDown':
          this.handleMove('down');
          break;
        case 'ArrowLeft':
          this.handleMove('left');
          break;
        case 'ArrowRight':
          this.handleMove('right');
          break;
      }
    },
    spawnTile(grid, tiles) {
      const emptyCells = [];
      for (let y = 0; y < GRID_SIZE; y++) {
        for (let x = 0; x < GRID_SIZE; x++) {
          if (grid[y][x] === null) {
            emptyCells.push({
              x,
              y
            });
          }
        }
      }
      if (emptyCells.length === 0) return {
        grid,
        tiles
      };
      const {
        x,
        y
      } = emptyCells[Math.floor(Math.random() * emptyCells.length)];
      const value = Math.random() < 0.9 ? 2 : 4;
      const newTile = {
        id: this.nextId++,
        value,
        x,
        y
      };
      const newGrid = grid.map(row => [...row]);
      newGrid[y][x] = value;
      return {
        grid: newGrid,
        tiles: [...tiles, newTile]
      };
    },
    async initGame() {
      await this.start();
      this.popStartShow = false;
      this.popLostShow = false;
      this.nextId = 0;
      let {
        grid,
        tiles
      } = this.spawnTile(Array(GRID_SIZE).fill(null).map(() => Array(GRID_SIZE).fill(null)), []);
      const secondSpawn = this.spawnTile(grid, tiles);
      this.gameState.grid = secondSpawn.grid;
      this.gameState.tiles = secondSpawn.tiles;
      this.gameState.score = 0;
      this.gameState.status = GameStatus.PLAYING;
      this.revives = this.maxRevives;
    },
    //'up' | 'down' | 'left' | 'right'
    handleMove(direction) {
      if (this.gameState.status !== GameStatus.PLAYING) return;
      const {
        tiles,
        score
      } = this.gameState;
      let currentTiles = tiles.map(t => ({
        ...t
      }));
      let currentScore = score;
      let moved = false;
      const isVertical = direction === 'up' || direction === 'down';
      const isInverted = direction === 'right' || direction === 'down';
      for (let i = 0; i < GRID_SIZE; i++) {
        // 1. 获取当前行/列的方块
        const lineTiles = Array(GRID_SIZE).fill(null);
        for (let j = 0; j < GRID_SIZE; j++) {
          const x = isVertical ? i : j;
          const y = isVertical ? j : i;
          const tile = currentTiles.find(t => t.x === x && t.y === y);
          lineTiles[j] = tile || null;
        }

        // 2. 如果是向右或向下，反转处理顺序
        if (isInverted) lineTiles.reverse();

        // 3. 压缩：移动所有方块到一侧
        const compressed = lineTiles.filter(t => t !== null);

        // 4. 合并
        const merged = [];
        for (let j = 0; j < compressed.length; j++) {
          const current = compressed[j];
          const next = compressed[j + 1];
          if (next && current.value === next.value) {
            const newValue = current.value * 2;
            currentScore += newValue;
            moved = true;

            // 保持 current 的 ID，这样动画更连贯，且不会出现“新方块不显示”的问题
            const updatedTile = {
              ...current,
              value: newValue
            };
            merged.push(updatedTile);

            // 从总列表中移除这两个旧方块
            currentTiles = currentTiles.filter(t => t.id !== current.id && t.id !== next.id);
            // 将更新后的方块加入总列表
            currentTiles.push(updatedTile);
            j++; // 跳过下一个
          } else {
            merged.push(current);
          }
        }

        // 5. 更新位置并检查是否移动
        if (isInverted) merged.reverse();
        for (let j = 0; j < merged.length; j++) {
          const tile = merged[j];
          const targetJ = isInverted ? GRID_SIZE - merged.length + j : j;
          const targetX = isVertical ? i : targetJ;
          const targetY = isVertical ? targetJ : i;
          if (tile.x !== targetX || tile.y !== targetY) {
            moved = true;
            const tileInList = currentTiles.find(t => t.id === tile.id);
            if (tileInList) {
              tileInList.x = targetX;
              tileInList.y = targetY;
            }
          }
        }
      }
      if (moved) {
        // 重新构建网格
        const newGrid = Array(GRID_SIZE).fill(null).map(() => Array(GRID_SIZE).fill(null));
        currentTiles.forEach(t => {
          newGrid[t.y][t.x] = t.value;
        });
        const spawned = this.spawnTile(newGrid, currentTiles);
        this.gameState.grid = spawned.grid, this.gameState.tiles = spawned.tiles, this.gameState.score = currentScore, this.gameState.status = this.checkGameOver(spawned.grid) ? GameStatus.GAMEOVER : GameStatus.PLAYING;
        //this.gameState.won = spawned.grid.some(row => row.some(cell => cell === 2048))
      }
    },

    checkGameOver(grid) {
      for (let y = 0; y < GRID_SIZE; y++) {
        for (let x = 0; x < GRID_SIZE; x++) {
          if (grid[y][x] === null) return false;
          const val = grid[y][x];
          if (x < GRID_SIZE - 1 && grid[y][x + 1] === val) return false;
          if (y < GRID_SIZE - 1 && grid[y + 1][x] === val) return false;
        }
      }
      return true;
    },
    handleCancel() {
      this.gameState.status = GameStatus.MENU;
    },
    handleRevive() {
      if (this.revives <= 0) return;
      const callback = res => {
        const newTiles = this.gameState.tiles.filter(t => t.value !== 2 && t.value !== 4);
        const newGrid = Array(GRID_SIZE).fill(null).map(() => Array(GRID_SIZE).fill(null));
        newTiles.forEach(t => {
          newGrid[t.y][t.x] = t.value;
        });
        this.gameState.grid = newGrid;
        this.gameState.tiles = newTiles;
        this.gameState.status = GameStatus.PLAYING;
        this.revives = this.revives - 1 >= 0 ? this.revives - 1 : 0;
      };
      try {
        let advData = getRandomElement(this.advList);
        if (advData) {
          gameAdv.show(advData, this.timePeriod, res => {
            callback(res);
          }, this);
        } else {
          callback(null);
        }
      } catch (e) {
        callback(null);
      }
    },
    // 复活逻辑：移除所有 2 和 4，腾出空间
    handleConfirm() {
      this.revives > 0 ? this.handleRevive() : this.handleCancel();
    },
    // H5 滑动检测
    handleTouchStart(e) {
      this.touchStart = {
        x: e.touches[0].clientX,
        y: e.touches[0].clientY
      };
    },
    handleTouchEnd(e) {
      if (!this.touchStart) return;
      const dx = e.changedTouches[0].clientX - this.touchStart.x;
      const dy = e.changedTouches[0].clientY - this.touchStart.y;
      const absX = Math.abs(dx);
      const absY = Math.abs(dy);
      if (Math.max(absX, absY) > 30) {
        if (absX > absY) {
          this.handleMove(dx > 0 ? 'right' : 'left');
        } else {
          this.handleMove(dy > 0 ? 'down' : 'up');
        }
      }
      this.touchStart = null;
    },
    getTileColor(value) {
      const colors = {
        2: 'bg-zinc-100 text-zinc-800',
        4: 'bg-zinc-200 text-zinc-800',
        8: 'bg-orange-100 text-orange-800',
        16: 'bg-orange-200 text-orange-900',
        32: 'bg-orange-300 text-orange-900',
        64: 'bg-orange-400 text-white',
        128: 'bg-yellow-200 text-yellow-900',
        256: 'bg-yellow-300 text-yellow-900',
        512: 'bg-yellow-400 text-white',
        1024: 'bg-yellow-500 text-white',
        2048: 'bg-yellow-600 text-white shadow-[0_0_20px_rgba(202,138,4,0.4)]'
      };
      return colors[value] || 'bg-zinc-800 text-white';
    },
    async start() {
      let rs = await this.$http.post("/game/start", {
        game_type: "2048"
      });
      vailcode(rs, () => {
        this.prizePool = rs.data.keys ?? 0;
        this.timePeriod = rs.data.time_period ?? "";
        this.leftTime = rs.data.left_time ?? 0;
        this.lastScore = rs.data.last_score ?? 0;
        this.countDown();
      });
    },
    async end() {
      if (this.lastScore >= this.gameState.score) return;
      let gameData = aesEncrypt(JSON.stringify({
        game_type: "2048",
        level: 1,
        score: this.gameState.score,
        time_period: this.timePeriod,
        time: new Date().getTime()
      }));
      let rs = await this.$http.post("/game/score", {
        gameData: gameData,
        '_n': 1
      });
      if (rs.code == 0) {
        // this.level = rs.data.level ?? 1;
        // this.score = rs.data.score ?? 0;
        this.prizePool = rs.data.keys ?? 0;
      }
    },
    async init() {
      let rs = await this.$http.post("/game/init", {
        game_type: "2048"
      });
      vailcode(rs, () => {
        this.leftTime = rs.data.left_time ?? 0;
        this.prizePool = rs.data.keys ?? 0;
        this.advList = rs.data.advList ?? [];
        this.timePeriod = rs.data.time_period ?? "";
        this.leftTime = rs.data.left_time ?? 0;
        this.userReward = rs.data.userReward ?? null;
        if (this.userReward?.total_keys > 0 || this.userReward?.total_taps > 0) {
          setTimeout(() => {
            this.popUserRewardShow = true;
          }, 500);
        }
        this.countDown();
      });
    },
    countDown() {
      clearTimeout(this.stimeVal);
      this.leftTime = this.leftTime - 1;
      this.$nextTick(() => {
        if (this.leftTime <= 0) {
          this.gameState.status = GameStatus.MENU;
          this.init();
        } else {
          this.stimeVal = setTimeout(() => {
            this.countDown();
          }, 1000);
        }
      });
    },
    viewRank() {
      this.$nextTick(() => {
        //  this.$router.push(`/game/rank`)
        //  console.log(this.$router)
        this.popGameRankShow = true;
      });
    },
    async handleGetRewardConfirm() {
      let rs = await this.$http.post("/game/get/reward", {
        game_type: "2048"
      });
      vailcode(rs, () => {
        this.popUserRewardShow = false;
      });
    },
    // Tile 生成动画
    runAppearAnimations() {
      let tiles = this.$refs.tiles;
      if (!tiles) return;
      if (!Array.isArray(tiles)) tiles = [tiles];
      tiles.forEach(el => {
        const inner = el.querySelector(".inner-tile");
        if (!inner) return;
        animate(inner, {
          scale: [0.9, 1],
          opacity: [0.9, 1]
        }, {
          duration: 0.25,
          easing: spring(500, 1, 30)
        });
      });
    },
    // Tile 合并动画
    runMergeAnimations() {
      // const tileEls = this.$el.querySelectorAll(".inner-tile");
      // tileEls.forEach(el => {
      //     animate(el, { scale: [0.8, 1] }, { duration: 0.15 });
      // });
    },
    // Tile 移动动画
    runMoveAnimations() {
      let tiles = this.$refs.tiles;
      if (!tiles) return;
      if (!Array.isArray(tiles)) tiles = [tiles];
      tiles.forEach(el => {
        const tile = this.gameState.tiles.find(t => t.id == el.dataset.id);
        if (!tile) return;
        animate(el, {
          transform: `translate(${tile.x * 100}%, ${tile.y * 100}%)`
        }, {
          duration: 0.2,
          easing: spring(500, 1, 30)
        });
      });
    }
  },
  async mounted() {
    if (!isOpenMobile()) {
      this.popOpenMobileShow = true;
      return;
    }
    await this.init();
    this.popStartShow = true;
    this.$nextTick(() => {
      this.$refs.gameCenterBoxInner.style.height = this.$refs.gameCenterBox.clientWidth + 'px';
      this.$refs.gameCenterBoxInner.style.display = 'block';
      window.addEventListener('keydown', this.handleKeyDown);
    });
  }
};